<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20" style="overflow-x: hidden">
				<el-row :gutter="20" class="h-100">
					<el-col :span="5" class="h-100">
						<group-table ref="groupTable" @SelectMenu="SelectMenu" :scrId="scrId" />
					</el-col>
					<el-col :span="5" class="h-100">
						<tree-container ref="treeSection" @SelectUserGroupScreenFunction="SelectUserGroupScreenFunction" :scrId="scrId" />
					</el-col>
					<el-col :span="14" class="h-100">
						<table-container ref="table" :Add="Add" :Save="Save" :Delete="Delete" :scrId="scrId" />
					</el-col>
				</el-row>
			</div>
		</div>
		<funcList-popup-container ref="funcListPopupContainer" @SetData="SetData" :scrId="scrId" />
		<copy-popup-container ref="copyPopupContainer" @Refresh="Refresh" :scrId="scrId" />
	</div>
</template>

<script>
import SearchContainer from './Search/SearchContainer.vue';
import GroupTable from './Table/GroupTable.vue';
import TreeContainer from './Tree/TreeContainer.vue';
import TableContainer from './Table/TableContainer.vue';
import FuncListPopupContainer from './FuncListPopup/PopupContainer.vue';
import CopyPopupContainer from './CopyPopup/PopupContainer.vue';
export default {
	props: {
		Add: {
			type: Function
		},
		Save: {
			type: Function
		},
		Delete: {
			type: Function
		},

		scrId: { type: String, default: '' }
	},
	components: { SearchContainer, GroupTable, TreeContainer, TableContainer, FuncListPopupContainer, CopyPopupContainer },
	methods: {
		Refresh() {
			this.$refs.searchContainer.searchList();
		},
		SelectMenu() {
			this.$refs.treeSection.setTreeList();
		},
		SelectUserGroupScreenFunction(param) {
			this.$refs.table.getData(param);
		},
		SetData(param) {
			this.$refs.table.addRow(param);
		}
	}
};
</script>

<style scoped>
.sf-card-column-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
